export default __webpack_public_path__ + "static/media/smart-grid.73a29640.svg";